










































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { localize, extend } from 'vee-validate';
import { FileFormResponse, InputProps, SelectProps } from '@/constants/form/types';
import SingleText from '@/components/common/elements/SingleText.vue';
import Icon from '@/components/common/elements/Icon.vue';
import RegistInputHeaderForm from '@/components/construction/constructionregister/RegistInputHeaderForm.vue';
import RegistInputForm from '@/components/construction/constructionregister/RegistInputForm.vue';

@Component({
  components: { 
    SingleText,
    Icon,
    RegistInputHeaderForm,
    RegistInputForm
   }
})
export default class EditPanelComponent extends Vue {
  @Prop()
  private basicFieldData: any;
  @Prop()
  private basicFieldCols: any;
  // 編集モード判定制御値
  @Prop({ default: true })
  private isEditMode?: boolean;
  @Prop({default: ''})
  private sumBillingAmount?: string;
  @Prop({default: ''})
  private billingBalance?: string;
  // 画面開閉状態
  private switchButtonValue?: boolean = false;
  // 開閉状態アイコン
  private switchButtonIcon?: string = 'mdi-chevron-down';

  /**
   * パネル開閉ボタン
   * 確認用 仕様不明の為仮実装
   * @module showDetailInformation
   * @param {boolean} flag - パネル開閉状態フラグ
   * @return {void} - コンソールに出力
   */
  private showDetailInformation() {
    if (this.switchButtonValue === true) {
      this.switchButtonValue = false;
      this.switchButtonIcon = 'mdi-chevron-down';
    } else {
      this.switchButtonValue = true;
      this.switchButtonIcon = 'mdi-chevron-up';
    }
  }

  // 登録用データ
  private registData: any = {};

  private onClickCancel(): void {
    this.$router.push({ name: 'ConstructionList'});
  }
  /**
   * 子コンポーネントからEmitされる値をコンソールに出力
   * （値が渡されるか確認用）
   * @module catchInput
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void} - コンソールに出力
   */
  @Emit('catchInput')
  private catchInput(response: any) {
    const name = response.name;
    const value = response.value;
    // ToDo:フォームのデータタイプに合わせて整形する必要あり
    this.registData[name] = value;
    this.sendData();
    return response;
  }

  /**
   * 子コンポーネントからEmitされた値をインサート・Update用に加工し親に渡す
   * @module sendData
   * @return {void} - Emit
   */
  @Emit('sendData')
  private sendData(){
    return this.registData;
  }

  @Emit('emitFileData')
  private emitFileData(data: FileFormResponse): FileFormResponse {
    return data;
  }

  @Emit('openFileManagerDialog')
  private openFileManagerDialog(isOpen: boolean): boolean {
    return isOpen;
  }

  /**
   * 子コンポーネントからEmitされる値を親コンポーネントに
   * （値が渡されるか確認用）
   * @module buttonAction
   * @param {string} type - 押下されたボタンのタイプ
   * @return {string} - 押下されたボタンのタイプ
   */
  @Emit('buttonAction')
  private buttonAction(type: string): string {
    return type;
  }
}
